import {Button, Form, Input, Modal} from 'antd';
import {FC, useEffect, useRef, useState} from 'react';
import apis from './apis/apis';
import {ILogin} from './apis/auth/auth';

type callbackFn = () => void;
// useRefCallback allow callback call newset function
function useRefCallback(callback: callbackFn): callbackFn {
  const ref = useRef<callbackFn>(callback);
  ref.current = callback; // always update ref,cunrrent
  return ()=>ref.current();
}

// see https://overreacted.io/zh-hans/making-setinterval-declarative-with-react-hooks/
// changed some code
function useInterval(fn: callbackFn, intervalSec: number | null) {
  const call = useRefCallback(fn);

  useEffect(() => {
    if (!intervalSec) return;
    const id = setInterval(call, intervalSec * 1000);
    return () => clearInterval(id);
  }, [intervalSec]);
}

// like useInterval, but with a timeout
// timeoutSec changes will reset timer
function useTimeout(fn: callbackFn, timeoutSec: number | null) {
  const call = useRefCallback(fn);
  useEffect(()=>{
    if (!timeoutSec) return;
    const id = setTimeout(call, timeoutSec * 1000);
    return ()=>clearTimeout(id);
  }, [timeoutSec]);
}

const storageExpireKey = 'auth/expire';
function storageGetExpire(): Date {
  const item = window.localStorage.getItem(storageExpireKey);
  if (!item) return new Date(0);
  return new Date(item);
}
function storageSetExpire(expire: Date) {
  window.localStorage.setItem(storageExpireKey, expire.toISOString());
}
function storageDelExpire() {
  window.localStorage.removeItem(storageExpireKey);
}

export const Login: FC = () => {
  const [expire, _setExpire] = useState(storageGetExpire());
  const [logining, setLogining] = useState(false);
  const [login, setLogin] = useState<ILogin>({
    Password: '',
  });
  const setExpire = (newExpire: Date) => {
    storageSetExpire(newExpire);
    _setExpire(newExpire);
  };


  const expired = expire < new Date();

  const doRefresh = (onError?: ()=>void) => {
    apis.auth.refresh().then((auth) => {
      // refresh success, set expire
      setExpire(new Date(auth.expire));
    }).catch(onError||(()=>{/* drop error*/}));
  };

  // check if already login, but expire not set corretly
  useEffect(()=>{
    if (!expired) {
      return;
    }
    doRefresh();
  }, [expire]);

  // if not expired, call refresh once on mount
  useEffect(()=>{
    if (expired) {
      return;
    }
    doRefresh();
  }, []);

  useInterval(doRefresh, expired ? null : 5 * 60);
  useTimeout(()=>doRefresh(()=>
    // above useInterface will update expire if refresh success
    // if this useTimeout is called, it means refresh failed for a long time,
    // set expire to 0, rerender on expired
    setExpire(new Date(0)),
  ), expired ? null : 30 * 60);


  const doLogin = async () => {
    setLogining(true);
    try {
      // const auth =
      await apis.auth.login(login);
      // setExpire(new Date(auth.expire));
      window.location.reload(); // reload page
    } catch (e: any) {
      // drop error
    } finally {
      setLogining(false);
    }
  };

  return <Modal
    title="Login"
    centered
    visible={expired}
    footer={[<Button type='primary' key='login' loading={logining} onClick={doLogin} >Login</Button>]}
  >
    <Form
      labelCol={{span: 8}}
      wrapperCol={{span: 16}}
      onFinish={doLogin}
    >
      <Form.Item label="Password"><Input type="password" value={login.Password} onChange={(e) => {
        setLogin({...login, Password: e.target.value});
      }} /></Form.Item>
    </Form>
  </Modal>;
};

export function logout() {
  // call logout, and reload page even logout failed
  apis.auth.logout().finally(()=>{
    storageDelExpire();
    window.location.reload();
  });
}


